export default __webpack_public_path__ + "static/car-4cd9ede126a84249216ff496ceef4468.png";